// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Env from "../../core/Env.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Page from "../../resources/layout-and-structure/Page.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Offset from "../../resources/layout-and-structure/Offset.res.js";
import * as Request from "../../core/Request.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as Accordion from "../../resources/layout-and-structure/Accordion.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as HelpCenter from "../../core/HelpCenter.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as NextBanner from "../../resources/feedback-indicators/NextBanner.res.js";
import * as TextAction from "../../resources/actions/TextAction.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as TooltipIcon from "../../resources/overlays/TooltipIcon.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as BillingAccount from "../../modules/Billing/BillingAccount.res.js";
import * as SettingsRoutes from "./SettingsRoutes.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BillingAccountInvoicesTable from "../../modules/Billing/BillingAccountInvoicesTable.res.js";

function decodeCustomerPlans(json) {
  let dict = Json.decodeDict(json);
  let match = Json.flatDecodeDictFieldString(dict, "kind");
  let match$1 = Json.flatDecodeDictField(dict, "upcomingInvoiceDate", Json.decodeNumber);
  let match$2 = Json.flatDecodeDictField(dict, "quantity", Json.decodeNumber);
  if (match === undefined) {
    return;
  }
  if (match$2 === undefined) {
    return;
  }
  let upcomingInvoiceDate = match$1 !== undefined ? new Date(match$1) : undefined;
  let match$3 = BillingAccount.BillingPlanKind.fromString(match);
  if (match$3.TAG === "Ok") {
    return {
      kind: match$3._0,
      upcomingInvoiceDate: upcomingInvoiceDate,
      quantity: match$2 | 0
    };
  }
}

function decodeCustomerOptions(json) {
  let dict = Json.decodeDict(json);
  let match = Json.flatDecodeDictFieldString(dict, "name");
  let match$1 = Json.flatDecodeDictField(dict, "upcomingInvoiceDate", Json.decodeNumber);
  let match$2 = Json.flatDecodeDictField(dict, "quantity", Json.decodeNumber);
  if (match === undefined) {
    return;
  }
  if (match$2 === undefined) {
    return;
  }
  let upcomingInvoiceDate = match$1 !== undefined ? new Date(match$1) : undefined;
  return {
    name: match,
    upcomingInvoiceDate: upcomingInvoiceDate,
    quantity: match$2 | 0
  };
}

function decodeResult(json) {
  let match = Json.flatDecodeDictFieldArray(Json.decodeDict(json), "plans");
  let match$1 = Json.flatDecodeDictFieldArray(Json.decodeDict(json), "options");
  if (match !== undefined && match$1 !== undefined) {
    return {
      plans: Stdlib_Array.filterMap(match, decodeCustomerPlans),
      options: Stdlib_Array.filterMap(match$1, decodeCustomerOptions)
    };
  }
}

let endpoint = Env.gatewayUrl() + "/customer-subscriptions/";

function make(shopId) {
  return Future.mapOk(Request.make(endpoint + shopId, "GET", undefined, undefined, undefined), undefined, decodeResult);
}

let SubscriptionsRequest = {
  decodeCustomerPlans: decodeCustomerPlans,
  decodeCustomerOptions: decodeCustomerOptions,
  decodeResult: decodeResult,
  endpoint: endpoint,
  make: make
};

function SettingsBillingAccountShowPage$SubscriptionsCard(props) {
  let subscriptions = props.subscriptions;
  let tmp;
  let exit = 0;
  if (subscriptions !== undefined && subscriptions.plans.length !== 0) {
    let tmp$1;
    if (subscriptions.options.length !== 0) {
      let triggerToggleView = JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(TextStyle.make, {
          children: I18n.t("Options"),
          weight: "strong"
        }),
        spaceY: "none"
      });
      tmp$1 = JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(Accordion.make, {
          children: JsxRuntime.jsx(Box.make, {
            children: JsxRuntime.jsx(Stack.make, {
              children: subscriptions.options.map(option => JsxRuntime.jsx(Box.make, {
                children: JsxRuntime.jsxs(TextStyle.make, {
                  children: [
                    I18n.t(option.name),
                    option.quantity > 1 ? " (x" + option.quantity.toString() + ")" : null
                  ],
                  opacity: 0.6
                }),
                spaceTop: "none",
                spaceLeft: "xsmall"
              })),
              space: "medium"
            }),
            spaceBottom: "small",
            spaceLeft: "xlarge"
          }),
          triggerShowView: triggerToggleView,
          triggerHideView: triggerToggleView
        }),
        spaceTop: "small"
      });
    } else {
      tmp$1 = null;
    }
    tmp = JsxRuntime.jsxs(Box.make, {
      children: [
        subscriptions.plans.map(plan => {
          let upcomingInvoiceDate = plan.upcomingInvoiceDate;
          let tmp;
          if (upcomingInvoiceDate !== undefined) {
            let formattedUpcomingInvoiceDate = I18n.t("Next charge on") + " " + I18n.dateTimeFormat(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, upcomingInvoiceDate) + ".";
            tmp = JsxRuntime.jsx(Offset.make, {
              children: JsxRuntime.jsx(TooltipIcon.make, {
                children: JsxRuntime.jsx(Tooltip.Span.make, {
                  text: formattedUpcomingInvoiceDate
                }),
                variation: "info"
              }),
              top: 1,
              height: 18
            });
          } else {
            tmp = null;
          }
          return JsxRuntime.jsxs(Inline.make, {
            children: [
              JsxRuntime.jsx(TextStyle.make, {
                children: I18n.t("Subscription"),
                variation: "primary",
                weight: "medium"
              }),
              JsxRuntime.jsxs(TextStyle.make, {
                children: [
                  I18n.t(BillingAccount.BillingPlanKind.toString(plan.kind)),
                  plan.quantity > 1 ? " (x" + plan.quantity.toString() + ")" : null
                ],
                variation: "primary",
                weight: "strong"
              }),
              tmp
            ],
            space: "xsmall"
          }, BillingAccount.BillingPlanKind.toString(plan.kind));
        }),
        tmp$1
      ],
      spaceTop: "xsmall",
      spaceBottom: "none"
    });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(Banner.make, {
      textStatus: {
        TAG: "Warning",
        _0: I18n.t("Unable to display information about your subscription.")
      }
    });
  }
  return JsxRuntime.jsx(Card.make, {
    children: JsxRuntime.jsxs(Stack.make, {
      children: [
        tmp,
        JsxRuntime.jsx(TextStyle.make, {
          children: I18n.t("Would you like to change your subscription?") + " "
        }),
        JsxRuntime.jsx(Button.make, {
          label: I18n.t("Contact us"),
          onPress: () => HelpCenter.showMessages()
        }),
        JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsx(TextAction.make, {
            text: I18n.t("Review the terms and conditions of sale."),
            highlighted: true,
            onPress: () => HelpCenter.showArticle(HelpCenter.termsAndConditions)
          }),
          spaceTop: "xsmall"
        })
      ],
      space: "medium"
    }),
    title: I18n.t("Subscription")
  });
}

let SubscriptionsCard = {
  make: SettingsBillingAccountShowPage$SubscriptionsCard
};

let i18nPrefix = "settings_billing_account_show_page.invoices_card.";

function SettingsBillingAccountShowPage$BillingInvoicesCard(props) {
  return JsxRuntime.jsxs(Card.make, {
    children: [
      JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsxs(NextBanner.make, {
          children: [
            JsxRuntime.jsx(NextBanner.Text.make, {
              text: I18n.t(i18nPrefix + "disclaimer.text") + " "
            }),
            JsxRuntime.jsx(NextBanner.Text.make, {
              text: "➔ " + I18n.t(i18nPrefix + "disclaimer.link"),
              bold: true,
              href: "https://mesfactures.isagri.fr",
              target: "_blank"
            })
          ],
          variation: "info"
        }),
        spaceX: "large",
        spaceBottom: "medium"
      }),
      JsxRuntime.jsx(BillingAccountInvoicesTable.make, {
        shopId: props.shopId,
        invoicesRequest: props.invoicesRequest,
        preview: true
      })
    ],
    title: I18n.t("Invoice history"),
    variation: "table",
    grow: true
  });
}

let BillingInvoicesCard = {
  i18nPrefix: i18nPrefix,
  make: SettingsBillingAccountShowPage$BillingInvoicesCard
};

function SettingsBillingAccountShowPage(props) {
  let notification = props.notification;
  let subscriptionsRequest = props.subscriptionsRequest;
  let shopId = props.shopId;
  let navigate = Navigation.useNavigate();
  let shops = Auth.useShops();
  let currentShop = Stdlib_Option.getExn(shops.find(shop => shop.id === shopId), undefined);
  let scope = Auth.useScope();
  let organisationAccount;
  organisationAccount = scope.TAG === "Organisation";
  let match = React.useState(() => AsyncResult.notAsked());
  let setState = match[1];
  let state = match[0];
  React.useEffect(() => {
    setState(param => "Loading");
    let future = subscriptionsRequest(shopId);
    Future.get(future, result => {
      if (result.TAG !== "Ok") {
        return setState(param => ({
          TAG: "Done",
          _0: {
            TAG: "Error",
            _0: undefined
          }
        }));
      }
      let subscriptions = result._0;
      setState(param => ({
        TAG: "Done",
        _0: {
          TAG: "Ok",
          _0: subscriptions
        }
      }));
    });
    return () => Future.cancel(future);
  }, [currentShop]);
  let onChangeShop = value => navigate({
    replace: true
  }, SettingsRoutes.billingAccountShowRoute(value.id, undefined));
  let headerActions = organisationAccount ? JsxRuntime.jsx(Inline.make, {
      children: JsxRuntime.jsx(Auth.SelectSingleShopFilter.make, {
        value: currentShop,
        onChange: onChangeShop
      })
    }) : null;
  let tmp;
  let exit = 0;
  let subscriptions;
  if (typeof state !== "object") {
    tmp = JsxRuntime.jsx(Placeholder.make, {
      status: "Loading"
    });
  } else if (state.TAG === "Reloading") {
    let subscriptions$1 = state._0;
    if (subscriptions$1.TAG === "Ok") {
      subscriptions = subscriptions$1._0;
      exit = 2;
    } else {
      exit = 1;
    }
  } else {
    let subscriptions$2 = state._0;
    if (subscriptions$2.TAG === "Ok") {
      subscriptions = subscriptions$2._0;
      exit = 2;
    } else {
      exit = 1;
    }
  }
  switch (exit) {
    case 1 :
      tmp = JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(Banner.make, {
          textStatus: {
            TAG: "Danger",
            _0: I18n.t("An unexpected error occured. Please try again or contact the support.")
          }
        }),
        spaceTop: "large"
      });
      break;
    case 2 :
      tmp = JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsxs(Group.make, {
          children: [
            JsxRuntime.jsx(SettingsBillingAccountShowPage$SubscriptionsCard, {
              subscriptions: subscriptions
            }),
            JsxRuntime.jsx(SettingsBillingAccountShowPage$BillingInvoicesCard, {
              shopId: shopId,
              invoicesRequest: props.invoicesRequest
            })
          ],
          grid: [
            "30%",
            "70%"
          ],
          wrap: false,
          grow: false,
          spaceX: "large"
        }),
        spaceTop: "large"
      });
      break;
  }
  return JsxRuntime.jsxs(Page.make, {
    children: [
      notification !== undefined ? JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsx(Banner.make, {
            textStatus: notification
          }),
          spaceTop: "large"
        }) : null,
      tmp
    ],
    variation: "compact",
    title: I18n.t("Subscription and billing"),
    renderHeaderActions: () => headerActions
  });
}

let subscriptionsRequest = make;

let make$1 = SettingsBillingAccountShowPage;

export {
  SubscriptionsRequest,
  SubscriptionsCard,
  BillingInvoicesCard,
  subscriptionsRequest,
  make$1 as make,
}
/* endpoint Not a pure module */
